import { z } from 'zod';
export const CreateTagSchema = z.object({
    name: z.string().min(1).max(50),
    color: z
        .string()
        .regex(/^#[0-9a-fA-F]{6}$/)
        .optional(),
});
export const UpdateTagSchema = CreateTagSchema.partial();
export const AssignTagsSchema = z.object({
    tagIds: z.array(z.string().cuid()),
});
export const TagResponseSchema = z.object({
    id: z.string(),
    name: z.string(),
    color: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const TagUsageSchema = z.object({
    clients: z.number(),
    invoices: z.number(),
    quotes: z.number(),
    lineItems: z.number(),
    expenses: z.number(),
});
export const TagWithUsageResponseSchema = TagResponseSchema.extend({
    usage: TagUsageSchema,
});
//# sourceMappingURL=tags.js.map